<section class="error-page">
  <h1 class="error-page__code">404</h1>
  <p class="error-page__message">The page you are looking for was not found.</p>
</section>
